import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    //（产妇）健康咨询记录表添加
    addMatarnalHeathRecord (params) {
        return httpTool.fetchPost(apiConst.addMatarnalHeathRecordUrl,params)
    },
    //（产妇）健康咨询记录表查询list数据
    matarnalHeathRecordList (params) {
        return httpTool.fetchPost(apiConst.matarnalHeathRecordUrl,params)
    },
    //（产妇）健康咨询记录表详情数据
    getMatarnalHeathRecord (params) {
        return httpTool.fetchPost(apiConst.getMatarnalHeathRecordUrl,params)
    },
    //（产妇）健康咨询记录表更新
    updateMatarnalHeathRecord (params) {
        return httpTool.fetchPost(apiConst.updateMatarnalHeathRecordUrl,params)
    },

    //（新生儿）健康咨询记录表添加
    addBabyHeathRecord (params) {
        return httpTool.fetchPost(apiConst.addBabyHeathRecordUrl,params)
    },
    //（新生儿）健康咨询记录表查询list数据
    BabyHeathRecord (params) {
        return httpTool.fetchPost(apiConst.BabyHeathRecordUrl,params)
    },
    //（新生儿）健康咨询记录表详情数据
    getBabyHeathRecord (params) {
        return httpTool.fetchPost(apiConst.getBabyHeathRecordUrl,params)
    },
    //（新生儿）健康咨询记录表更新
    updateBabyHeathRecord (params) {
        return httpTool.fetchPost(apiConst.updateBabyHeathRecordUrl,params)
    },

    //产妇特殊护理记录添加
    addMatarnalSpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.addMatarnalSpecialNursingRecordUrl,params)
    },
    //产妇特殊护理记录list数据
    MatarnalSpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.MatarnalSpecialNursingRecordUrl,params)
    },
    //产妇特殊护理记录详情数据
    getMatarnalSpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.getMatarnalSpecialNursingRecordUrl,params)
    },
    //产妇特殊护理记录更新
    updateMatarnalSpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.updateMatarnalSpecialNursingRecordUrl,params)
    },

    //婴儿特殊护理记录添加
    addBabySpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.addBabySpecialNursingRecordUrl,params)
    },
    //婴儿特殊护理记录list数据
    babySpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.babySpecialNursingRecordUrl,params)
    },
    //婴儿特殊护理记录详情数据
    getBabySpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.getBabySpecialNursingRecordUrl,params)
    },
    //婴儿特殊护理记录更新
    updateBabySpecialNursingRecord (params) {
        return httpTool.fetchPost(apiConst.updateBabySpecialNursingRecordUrl,params)
    },
}


// WEBPACK FOOTER //
// ./src/service/api/repository/chritmasForm-api.js